import React, { useEffect, useState } from 'react';
import { ReactComponent as DHLLogo } from '../../resources/images/dhl_logo.svg';
import '../base-styles/fonts.css';
import './styles/LandingStyle.css';
import { languageMap } from '../../maps/languageMap';
import { navigationPages } from '../../models/types/navigationPageType';
import { useActions, useTypedSelector } from '../../hooks';
import { useHistory } from 'react-router-dom';

const CURRENT_VERSION = process.env.REACT_APP_CURRENT_VERSION;

const Landing: React.FC = () => {
  let history = useHistory();
  const [imageClassList, setImageClassList] = useState(['']);
  const [activeImageClass, setActiveImageClass] = useState('landing1');
  const language = useTypedSelector((state) => {
    return state.session.language;
  });
  const tokenExpirationTime = useTypedSelector((state) => {
    return state.session.tokenExpirationTime;
  });

  const { sessionUpdateDHLTokenExpired } = useActions();
  useEffect(() => {
    setImageClassList(['landing1', 'landing2', 'landing3', 'landing4']);
    document.body.style.overscrollBehaviorY = 'auto';
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      let i = imageClassList.indexOf(activeImageClass);
      let j = i + 1;
      if (j > imageClassList.length - 1) {
        j = 0;
      }
      setActiveImageClass(imageClassList[j]);
    }, 8000);
    return () => clearTimeout(timer);
  }, [imageClassList, activeImageClass]);

  const checkTokenExpired = () => {
    let current_time = Date.now();
    console.log('Seconds left: ', tokenExpirationTime - current_time);
    if (current_time > tokenExpirationTime && tokenExpirationTime !== 0) {
      console.log('Updating token expired');
      sessionUpdateDHLTokenExpired(true);
      return false;
    }
    return true;
  };
  const navigateFromLanding = () => {
    if (!checkTokenExpired()) {
      return;
    }
    document.body.style.overscrollBehaviorY = 'contain';
    history.replace(`/${navigationPages.CLIENT_RETRIEVAL_SCAN_AWB}`);
  };
  return (
    <div id="landing" className="main-container">
      <div
        data-cy="landing-button"
        className="landing-button"
        onClick={() => navigateFromLanding()}
      />
      <div className="landing-image-container">
        {imageClassList.map((imgClass) => {
          return (
            <div
              key={imgClass}
              className={`landing-image-container landing-image ${imgClass} ${
                imgClass === activeImageClass ? 'active' : ''
              }`}
            />
          );
        })}
      </div>
      <div className="banner" />
      <DHLLogo className="dhl-logo" />
      <div className="title-container">
        <p className="title-main">{languageMap.landing.title[language]}</p>
        <p className="title-secondary">
          {languageMap.landing.subtitle[language]}
        </p>
      </div>
      <div className="version-container">
        <p className="version main">v {CURRENT_VERSION}</p>
      </div>
      <div className="message-container">
        <p className="message">{languageMap.landing.instructions[language]}</p>
      </div>
    </div>
  );
};

export { Landing };
